export default __webpack_public_path__ + "static/media/qr_code_pix.9cbc2c0f.png";